import { ref, reactive, defineComponent, useCssVars, computed, onUpdated, onMounted, openBlock, createBlock, Transition, withCtx, withDirectives, createElementVNode, normalizeStyle, unref, normalizeClass, createCommentVNode, createElementBlock, Fragment, renderList, resolveDynamicComponent, mergeProps, createVNode, vShow, provide, withModifiers, defineAsyncComponent, getCurrentInstance, inject } from "vue";
import { ToolActionKind, FontType, TextTransform, ButtonStyleKind, RadiusKind, MeasureUnit, ToolModuleKind, ButtonActionKind, Locale, DeviceKind, activityKindLiteralMap, perkTooltipKindLiteralMap, LocaleImageKind, ToolKind, ToolPosition, DefaultStep, CountdownKind, CountdownTimezone } from "@thehotelsnetwork/personalization-types";
import "tinycolor2";
import { useElementSize, useSwipe } from "@vueuse/core";
import { CrossIcon } from "@thehotelsnetwork/icons/vue/linear";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const __variableDynamicImportRuntimeHelper$$$ = (glob, path) => {
  const v = glob[path];
  if (v) {
    return typeof v === "function" ? v() : Promise.resolve(v);
  }
  return new Promise((_, reject) => {
    (typeof queueMicrotask === "function" ? queueMicrotask : setTimeout)(reject.bind(null, new Error("Unknown variable dynamic import: " + path)));
  });
};
var ButtonState = /* @__PURE__ */ ((ButtonState2) => {
  ButtonState2["Active"] = "active";
  ButtonState2["Sending"] = "sending";
  ButtonState2["Success"] = "success";
  ButtonState2["Failure"] = "failure";
  return ButtonState2;
})(ButtonState || {});
const requireFeedbackStepActions = [
  ToolActionKind.SendForm,
  ToolActionKind.SendSaveSearch,
  ToolActionKind.SendSubscribe
];
const requireHideToolActions = [
  ToolActionKind.ApplyDiscount,
  ToolActionKind.OpenUri,
  ToolActionKind.OpenBookingEngine,
  ToolActionKind.EmptyClick,
  ToolActionKind.Dismiss
];
const closingToolActions = [
  ToolActionKind.Hide
];
class HandlersStore {
  constructor() {
    __publicField(this, "dataValidators", {});
    __publicField(this, "state", reactive({
      actions: [],
      buttonState: ButtonState.Active,
      stepActive: DefaultStep.Main,
      stepPrevious: null,
      isFirstStep: true,
      hideFunction: () => {
      }
    }));
  }
  get buttonState() {
    return this.state.buttonState;
  }
  get isFirstStep() {
    return this.state.isFirstStep;
  }
  get stepActive() {
    return this.state.stepActive;
  }
  get stepPrevious() {
    return this.state.stepPrevious;
  }
  initialize(hideFunction, actions) {
    this.state.hideFunction = hideFunction;
    this.state.actions = actions;
  }
  setDataValidator(kind, validateFunction) {
    this.dataValidators[kind] = validateFunction;
  }
  async callHandler(kind, moduleId) {
    if (!this.state.actions)
      return;
    let handlerData = {};
    const dataValidator = this.dataValidators[kind];
    if (dataValidator) {
      handlerData = await dataValidator();
      if (!handlerData) {
        return;
      }
    }
    let handlerAction;
    const findCallbackFn = [
      (action) => action.kind === kind,
      (action) => action.kind === ToolActionKind.Fallback
    ];
    if (moduleId) {
      findCallbackFn.unshift((action) => action.moduleId === moduleId);
    }
    for (let i = 0; !handlerAction && i < findCallbackFn.length; i += 1) {
      handlerAction = this.state.actions.find(findCallbackFn[i]);
    }
    if (!handlerAction)
      return;
    let response = false;
    if (handlerAction.handler) {
      this.state.buttonState = ButtonState.Sending;
      response = await handlerAction.handler(handlerData);
      this.state.buttonState = ButtonState.Active;
    }
    if (requireFeedbackStepActions.includes(kind)) {
      this.state.stepActive = response ? DefaultStep.Success : DefaultStep.Failure;
      this.state.isFirstStep = false;
    }
    if (requireHideToolActions.includes(kind)) {
      this.callHandler(ToolActionKind.Hide);
    }
    if (closingToolActions.includes(kind)) {
      this.state.hideFunction();
    }
  }
  goBackToMainStep() {
    this.state.stepPrevious = this.state.stepActive;
    this.state.stepActive = DefaultStep.Main;
    this.state.isFirstStep = true;
  }
  reset() {
    this.state.buttonState = ButtonState.Active;
    this.state.stepActive = DefaultStep.Main;
    this.state.isFirstStep = true;
  }
}
function hexToRgba(hexStr, alpha = 1) {
  let hex = hexStr.replace("#", "");
  if (![3, 6].includes(hex.length)) {
    return null;
  }
  if (hex.length === 3) {
    hex = hex.split("").map((hexChar) => hexChar + hexChar).join("");
  }
  const c = parseInt(hex, 16);
  return `rgba(${c >> 16 & 255},${c >> 8 & 255},${c & 255},${alpha})`;
}
function toPascalCase(str) {
  const tempStr = str.replace(/[-_\s]+(.)?/g, (_match, ch) => ch ? ch.toUpperCase() : "");
  return tempStr.substring(0, 1).toUpperCase() + tempStr.substring(1);
}
function toKebabCase(str) {
  return str.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
}
function getCornerRadius(refKind) {
  const kind = (refKind == null ? void 0 : refKind.kind) || RadiusKind.Rounded;
  switch (kind) {
    case RadiusKind.Custom:
      const customKind = refKind;
      return `${customKind.value}${customKind.format}`;
    case RadiusKind.Square:
      return "0px";
    case RadiusKind.Medium:
      return "6px";
    case RadiusKind.Rounded:
    default:
      return "16px";
  }
}
function appendPx(num = 0) {
  return `${num}px`;
}
function appendEm(num = 0) {
  return `${num}em`;
}
function getEmByPercent(percent) {
  return `${percent * 6 / 100}em`;
}
function getPaddingLiteral({
  format,
  top,
  right,
  bottom,
  left
}) {
  switch (format) {
    case MeasureUnit.Pixels:
      return `${top}${format} ${right}${format} ${bottom}${format} ${left}${format}`;
    case MeasureUnit.Em:
    default:
      return `${getEmByPercent(top)} ${getEmByPercent(right)} ${getEmByPercent(bottom)} ${getEmByPercent(left)}`;
  }
}
function isObj(object) {
  return (object == null ? void 0 : object.constructor) === Object;
}
const buttonActionTypesMap = {
  apply_promo_code: ToolActionKind.ApplyDiscount,
  close_tool: ToolActionKind.EmptyClick,
  emailCapture: ToolActionKind.SendSubscribe,
  form: ToolActionKind.SendForm,
  open_url: ToolActionKind.OpenUri,
  call_phone_number: ToolActionKind.OpenUri,
  open_mail_client: ToolActionKind.OpenUri,
  savedSearch: ToolActionKind.SendSaveSearch,
  send_to_be: ToolActionKind.OpenBookingEngine
};
function getButtonActionType(type) {
  return buttonActionTypesMap[type];
}
function getTransitionName(baseName, position = ToolPosition.UpperLeft) {
  let transition = baseName;
  switch (position) {
    case ToolPosition.Top:
      transition += "-from-top";
      break;
    case ToolPosition.Bottom:
      transition += "-from-bottom";
      break;
    default:
      transition += `-from-${position.slice(-1) === "L" ? "left" : "right"}`;
      break;
  }
  return transition;
}
var objectProto$6 = Object.prototype;
function isPrototype(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$6;
  return value === proto;
}
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var nativeKeys = overArg(Object.keys, Object);
const nativeKeys$1 = nativeKeys;
var objectProto$5 = Object.prototype;
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys$1(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$4.call(object, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
const freeGlobal$1 = freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal$1 || freeSelf || Function("return this")();
const root$1 = root;
var Symbol$1 = root$1.Symbol;
const Symbol$2 = Symbol$1;
var objectProto$4 = Object.prototype;
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
var nativeObjectToString$1 = objectProto$4.toString;
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty$3.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var objectProto$3 = Object.prototype;
var nativeObjectToString = objectProto$3.toString;
function objectToString(value) {
  return nativeObjectToString.call(value);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
function isObject(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var coreJsData = root$1["__core-js_shared__"];
const coreJsData$1 = coreJsData;
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype, objectProto$2 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
function getValue(object, key) {
  return object == null ? void 0 : object[key];
}
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}
var DataView = getNative(root$1, "DataView");
const DataView$1 = DataView;
var Map = getNative(root$1, "Map");
const Map$1 = Map;
var Promise$1 = getNative(root$1, "Promise");
const Promise$2 = Promise$1;
var Set = getNative(root$1, "Set");
const Set$1 = Set;
var WeakMap = getNative(root$1, "WeakMap");
const WeakMap$1 = WeakMap;
var mapTag$2 = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag$2 = "[object Set]", weakMapTag$1 = "[object WeakMap]";
var dataViewTag$1 = "[object DataView]";
var dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$2), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1);
var getTag = baseGetTag;
if (DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$1 || Map$1 && getTag(new Map$1()) != mapTag$2 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$1 && getTag(new Set$1()) != setTag$2 || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag$1) {
  getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$1 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$1;
        case mapCtorString:
          return mapTag$2;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$2;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}
const getTag$1 = getTag;
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var argsTag$1 = "[object Arguments]";
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$1;
}
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
var propertyIsEnumerable = objectProto$1.propertyIsEnumerable;
var isArguments = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$1.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
const isArguments$1 = isArguments;
var isArray = Array.isArray;
const isArray$1 = isArray;
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}
function stubFalse() {
  return false;
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var Buffer2 = moduleExports$1 ? root$1.Buffer : void 0;
var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
var isBuffer = nativeIsBuffer || stubFalse;
const isBuffer$1 = isBuffer;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag$1 = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var freeProcess = moduleExports && freeGlobal$1.process;
var nodeUtil = function() {
  try {
    var types = freeModule && freeModule.require && freeModule.require("util").types;
    if (types) {
      return types;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e) {
  }
}();
const nodeUtil$1 = nodeUtil;
var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
const isTypedArray$1 = isTypedArray;
var mapTag = "[object Map]", setTag = "[object Set]";
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) && (isArray$1(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer$1(value) || isTypedArray$1(value) || isArguments$1(value))) {
    return !value.length;
  }
  var tag = getTag$1(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}
const defaultColorStyles = {
  heading: "#000000",
  paragraph: "#000000",
  link: "#1C8BF1",
  buttonText: "#FFFFFF",
  buttonBackground: "#000000",
  background: {
    base: "#FFFFFF"
  },
  icon: "#000000",
  perks: "#000000",
  countdown: "#F2F2F2",
  countdownText: "#000000",
  countdownNumber: "#000000"
};
const defaultFontsStyles = {
  heading: {
    spec: {
      key: "Playfair+Display",
      name: "Playfair Display",
      cssName: "Playfair Display",
      type: "serif",
      fontType: FontType.Google,
      source: ""
    },
    style: "bold",
    textTransform: TextTransform.None
  },
  paragraph: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: FontType.Google,
      source: ""
    },
    style: "regular",
    textTransform: TextTransform.None
  },
  formFieldName: {
    spec: {
      key: "Source+Sans+Pro",
      name: "Source Sans Pro",
      cssName: "Source Sans Pro",
      type: "sans-serif",
      fontType: FontType.Google,
      source: ""
    },
    style: "regular",
    textTransform: TextTransform.None
  },
  other: {
    spec: {
      key: "Source+Sans+Pro",
      name: "Source Sans Pro",
      cssName: "Source Sans Pro",
      type: "sans-serif",
      fontType: FontType.Google,
      source: ""
    },
    style: "regular",
    textTransform: TextTransform.None
  },
  button: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: FontType.Google,
      source: ""
    },
    style: "regular",
    textTransform: TextTransform.None
  }
};
const defaultButtonStyles = {
  note: {
    style: ButtonStyleKind.Solid,
    cornerRadius: {
      kind: RadiusKind.Medium
    },
    padding: {
      top: 8,
      right: 16,
      bottom: 8,
      left: 16,
      format: MeasureUnit.Em
    }
  },
  layer: {
    style: ButtonStyleKind.Solid,
    cornerRadius: {
      kind: RadiusKind.Medium
    },
    padding: {
      top: 14,
      right: 22,
      bottom: 14,
      left: 22,
      format: MeasureUnit.Em
    }
  },
  exit: {
    style: ButtonStyleKind.Solid,
    cornerRadius: {
      kind: RadiusKind.Medium
    },
    padding: {
      top: 14,
      right: 22,
      bottom: 14,
      left: 22,
      format: MeasureUnit.Em
    }
  },
  inliner: {
    style: ButtonStyleKind.Solid,
    cornerRadius: {
      kind: RadiusKind.Medium
    },
    padding: {
      top: 14,
      right: 22,
      bottom: 14,
      left: 22,
      format: MeasureUnit.Em
    }
  }
};
const defaultBackgroundStyles = {
  opacity: 100,
  cornerRadius: {
    kind: RadiusKind.Medium
  }
};
const defaultInlinerBackgroundStyles = {
  opacity: 100,
  cornerRadius: {
    kind: RadiusKind.Medium
  },
  border: {
    color: "#D9D9D9",
    thickness: 1
  }
};
const defaultOverlayStyles = {
  color: "#000000",
  opacity: 50
};
function useDefaultStyles(type) {
  const toolType = ref(type);
  const defaultButtonStylesByTool = computed(
    () => defaultButtonStyles[toolType.value] || defaultButtonStyles.layer
  );
  return reactive({
    colors: { ...defaultColorStyles },
    fonts: { ...defaultFontsStyles },
    button: { ...defaultButtonStylesByTool.value },
    background: toolType.value === "inliner" ? { ...defaultInlinerBackgroundStyles } : { ...defaultBackgroundStyles },
    overlay: { ...defaultOverlayStyles }
  });
}
function parseToolData({
  tool,
  context,
  toolKind
}) {
  let layout;
  let position;
  let tokens;
  let embedded;
  const {
    builderMode,
    defaultAssets,
    deviceViewport,
    firstVisitDate,
    actions,
    hotelTimezone,
    hotelTimezoneOffset,
    language,
    countdownTimestamp
  } = context;
  if (isEmpty(tool.theme.styles) || !tool.theme.styles) {
    tool.theme.styles = useDefaultStyles(toolKind);
  }
  const {
    content: {
      modules
    },
    settings: {
      devices
    },
    theme: {
      styles
    }
  } = tool;
  if (toolKind !== ToolKind.Note) {
    layout = tool.settings.layout;
  } else {
    tokens = tool.tokens;
  }
  if (toolKind === ToolKind.Inliner) {
    embedded = tool.settings.embedded;
  }
  if (devices) {
    position = devices[deviceViewport].position;
  }
  const extraData = {
    builderMode,
    firstVisitDate,
    hotelTimezone,
    hotelTimezoneOffset,
    defaultAssets,
    countdownTimestamp,
    tokens
  };
  return {
    language,
    device: deviceViewport,
    position,
    modules,
    layout,
    styles,
    actions,
    extraData,
    embedded
  };
}
function toTitleCase(text) {
  const smallWords = /^(&|&amp;|a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i;
  const alphanumericPattern = /([A-Za-z0-9\u00C0-\u00FF])/;
  const wordSeparators = /([ :–—-])/;
  return text.split(wordSeparators).map((current, index, array) => {
    if (current.search(smallWords) > -1 && index !== 0 && index !== array.length - 1 && array[index - 3] !== ":" && array[index + 1] !== ":" && (array[index + 1] !== "-" || array[index - 1] === "-" && array[index + 1] === "-")) {
      return current.toLowerCase();
    }
    if (current.substring(1).search(/[A-Z]|\../) > -1) {
      return current;
    }
    if (array[index + 1] === ":" && array[index + 2] !== "") {
      return current;
    }
    return current.replace(alphanumericPattern, (match) => match.toUpperCase());
  }).join("");
}
function parseCssValue(key, value) {
  switch (key) {
    case "opacity":
      return (parseInt(value, 10) / 100).toString();
    case "thickness":
      return appendPx(parseInt(value, 10));
    case "cssName":
      return `'${value}'`;
    default:
      return value;
  }
}
function parseCssObjectValue(key, value) {
  switch (key) {
    case "cornerRadius":
      return getCornerRadius(value);
    case "padding":
      return getPaddingLiteral(value);
    default:
      return null;
  }
}
function getCssVarNames(styles, prefix) {
  return Object.keys(styles).reduce((stylesObj, key) => {
    var _a;
    let value = parseCssValue(key, (_a = styles[key]) == null ? void 0 : _a.toString());
    if (isObj(styles[key])) {
      value = parseCssObjectValue(key, styles[key]);
      if (!value) {
        const newObj = {
          ...stylesObj,
          ...getCssVarNames(styles[key], `${prefix}-${key}`)
        };
        return newObj;
      }
    }
    stylesObj[`${prefix}-${toKebabCase(key)}`] = value;
    return stylesObj;
  }, {});
}
class StylesStore {
  constructor() {
    __publicField(this, "rootDom", null);
    __publicField(this, "state", reactive({
      colors: {},
      fonts: {},
      button: {},
      background: {},
      overlay: {}
    }));
  }
  get rootElement() {
    return this.rootDom;
  }
  get fonts() {
    return this.state.fonts;
  }
  get backgroundImage() {
    var _a, _b;
    return (_b = (_a = this.state.background.image) == null ? void 0 : _a.urls) == null ? void 0 : _b.edited;
  }
  get backgroundImageAlt() {
    var _a;
    return (_a = this.state.background.image) == null ? void 0 : _a.alt;
  }
  get colors() {
    return this.state.colors;
  }
  get button() {
    return this.state.button;
  }
  initialize(styles, rootDom) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
    this.rootDom = rootDom;
    this.state.colors = styles.colors || {};
    this.state.fonts = styles.fonts || {};
    this.state.button = styles.button || {};
    this.state.background = styles.background || {};
    this.state.overlay = styles.overlay || {};
    const cssVars = getCssVarNames(this.state, "--thn-tool");
    this.addCssVariables({
      ...cssVars,
      "--thn-tool-colors-icon-back": hexToRgba(((_a = styles.colors) == null ? void 0 : _a.icon) || "#000000", 0.15),
      "--thn-tool-colors-background": ((_c = (_b = styles.colors) == null ? void 0 : _b.background) == null ? void 0 : _c.gradient) ? `linear-gradient(to right bottom, ${(_e = (_d = styles.colors) == null ? void 0 : _d.background) == null ? void 0 : _e.base}, ${(_g = (_f = styles.colors) == null ? void 0 : _f.background) == null ? void 0 : _g.gradient})` : (_i = (_h = styles.colors) == null ? void 0 : _h.background) == null ? void 0 : _i.base,
      "--thn-tool-button-background-color": ((_j = styles.button) == null ? void 0 : _j.style) === ButtonStyleKind.Solid ? (_k = styles.colors) == null ? void 0 : _k.buttonBackground : "transparent",
      "--thn-tool-button-border": ((_l = styles.button) == null ? void 0 : _l.style) === ButtonStyleKind.Outline ? `solid 2px ${(_m = styles.colors) == null ? void 0 : _m.buttonBackground}` : "transparent",
      "--thn-tool-background-border": ((_o = (_n = styles.background) == null ? void 0 : _n.border) == null ? void 0 : _o.color) ? `solid ${cssVars["--thn-tool-background-border-thickness"]} ${styles.background.border.color}` : "none"
    });
  }
  addCssVariables(cssVars) {
    Object.keys(cssVars).forEach((key) => {
      var _a;
      (_a = this.rootDom) == null ? void 0 : _a.style.setProperty(key, cssVars[key] || "");
    });
  }
  getCssVariableValue(variableName) {
    return this.rootDom && getComputedStyle(this.rootDom).getPropertyValue(variableName);
  }
}
class LiteralsStore {
  constructor() {
    __publicField(this, "state", reactive({
      language: Locale.English,
      device: DeviceKind.Desktop,
      literals: {}
    }));
  }
  get device() {
    return this.state.device;
  }
  get language() {
    return this.state.language;
  }
  async initialize(language, device) {
    this.state.language = language != null ? language : Locale.English;
    this.state.device = device != null ? device : DeviceKind.Desktop;
    const literals = await __variableDynamicImportRuntimeHelper$$$(/* @__PURE__ */ Object.assign({ "../locales/ar.json": () => import("./note-p-components-ar.js"), "../locales/bg.json": () => import("./note-p-components-bg.js"), "../locales/ca.json": () => import("./note-p-components-ca.js"), "../locales/cs.json": () => import("./note-p-components-cs.js"), "../locales/da.json": () => import("./note-p-components-da.js"), "../locales/de.json": () => import("./note-p-components-de.js"), "../locales/el.json": () => import("./note-p-components-el.js"), "../locales/en.json": () => import("./note-p-components-en.js"), "../locales/es.json": () => import("./note-p-components-es.js"), "../locales/et.json": () => import("./note-p-components-et.js"), "../locales/eu.json": () => import("./note-p-components-eu.js"), "../locales/fi.json": () => import("./note-p-components-fi.js"), "../locales/fr.json": () => import("./note-p-components-fr.js"), "../locales/he.json": () => import("./note-p-components-he.js"), "../locales/hr.json": () => import("./note-p-components-hr.js"), "../locales/hu.json": () => import("./note-p-components-hu.js"), "../locales/id.json": () => import("./note-p-components-id.js"), "../locales/is.json": () => import("./note-p-components-is.js"), "../locales/it.json": () => import("./note-p-components-it.js"), "../locales/ja.json": () => import("./note-p-components-ja.js"), "../locales/ko.json": () => import("./note-p-components-ko.js"), "../locales/lt.json": () => import("./note-p-components-lt.js"), "../locales/nl.json": () => import("./note-p-components-nl.js"), "../locales/no.json": () => import("./note-p-components-no.js"), "../locales/pl.json": () => import("./note-p-components-pl.js"), "../locales/pt.json": () => import("./note-p-components-pt.js"), "../locales/ro.json": () => import("./note-p-components-ro.js"), "../locales/ru.json": () => import("./note-p-components-ru.js"), "../locales/sl.json": () => import("./note-p-components-sl.js"), "../locales/sv.json": () => import("./note-p-components-sv.js"), "../locales/th.json": () => import("./note-p-components-th.js"), "../locales/tr.json": () => import("./note-p-components-tr.js"), "../locales/uk.json": () => import("./note-p-components-uk.js"), "../locales/vi.json": () => import("./note-p-components-vi.js"), "../locales/zh-TW.json": () => import("./note-p-components-zh-TW.js"), "../locales/zh.json": () => import("./note-p-components-zh.js") }), `../locales/${this.state.language}.json`);
    this.state.literals = literals.default;
  }
  getLiteral(key, titleCase) {
    return titleCase ? toTitleCase(this.state.literals[key] || key) : this.state.literals[key] || key;
  }
  getLiteralAbb(key, titleCase) {
    const abbrKey = `${key}_abbr`;
    return this.getLiteral(abbrKey, titleCase);
  }
  getActivityLiteral(textKey, tokens = {}) {
    var _a;
    const interpolationValue = tokens[textKey];
    if (interpolationValue) {
      return (_a = this.state.literals[activityKindLiteralMap[textKey]]) == null ? void 0 : _a.replace("XXXXXX", interpolationValue);
    }
    return this.state.literals[activityKindLiteralMap[textKey]];
  }
  getPerkActiveLiteral(perkDescription, titleCase = false) {
    const activeText = perkDescription[this.state.language] || "";
    return titleCase ? toTitleCase(activeText) : activeText;
  }
  getPerkTooltipLiteral(textKey) {
    return this.state.literals[perkTooltipKindLiteralMap[textKey]];
  }
  getActiveModuleText(props, titleCase = false) {
    const activeText = props[this.device][this.language] || "";
    return titleCase ? toTitleCase(activeText) : activeText;
  }
  getLocaleImageUrl(imageSettings) {
    var _a;
    switch (imageSettings.languageType) {
      case LocaleImageKind.Multi:
        return (_a = imageSettings.urls[this.language || Locale.English]) == null ? void 0 : _a.edited;
      case LocaleImageKind.Single:
      default:
        return imageSettings.urls.edited;
    }
  }
  getLocaleImageAlt(imageSettings) {
    switch (imageSettings.languageType) {
      case LocaleImageKind.Multi:
        return imageSettings.alt[this.language || Locale.English];
      case LocaleImageKind.Single:
      default:
        return imageSettings.alt;
    }
  }
}
class ExtraDataStore {
  constructor() {
    __publicField(this, "initTime", Date.now());
    __publicField(this, "state", reactive({
      builderMode: false,
      firstVisitDate: null,
      hotelTimezone: "Europe/Madrid",
      defaultAssets: void 0,
      countdownTimestamp: void 0,
      tokens: {}
    }));
  }
  get countdownInitTime() {
    return this.initTime;
  }
  get builderMode() {
    return this.state.builderMode;
  }
  get defaultAssets() {
    return this.state.defaultAssets;
  }
  get countdownTimestamp() {
    return this.state.countdownTimestamp;
  }
  get tokens() {
    return this.state.tokens;
  }
  initialize(data) {
    this.state.builderMode = !!data.builderMode;
    this.state.firstVisitDate = data.firstVisitDate;
    this.state.hotelTimezone = data.hotelTimezone;
    this.state.hotelTimezoneOffset = data.hotelTimezoneOffset;
    this.state.defaultAssets = data.defaultAssets;
    this.state.countdownTimestamp = data.countdownTimestamp;
    this.state.tokens = data.tokens;
  }
  getCountdownTimestamp(kind, details) {
    const {
      date = Date.now(),
      timezone,
      days = 0,
      hours = 0,
      minutes = 0
    } = details;
    this.initTime = Date.now();
    if (kind === CountdownKind.Time) {
      const daysMs = days * 24 * 60 * 60 * 1e3;
      const hoursMs = hours * 60 * 60 * 1e3;
      const minutesMs = minutes * 60 * 1e3;
      const discountMs = this.state.firstVisitDate ? this.initTime - this.state.firstVisitDate : 0;
      return this.initTime + daysMs + hoursMs + minutesMs - discountMs;
    }
    if (kind === CountdownKind.Date && date) {
      const dateEndDate = new Date(date);
      dateEndDate.setHours(hours);
      dateEndDate.setMinutes(minutes);
      if (timezone === CountdownTimezone.Hotel) {
        if (!this.state.hotelTimezoneOffset && this.state.hotelTimezone) {
          const timezoneDate = new Date().toLocaleString("en-US", {
            timeZone: this.state.hotelTimezone
          });
          const timezoneMs = new Date(timezoneDate).getTime();
          const timezoneOffset = timezoneMs - new Date().getTime();
          dateEndDate.setTime(dateEndDate.getTime() - timezoneOffset);
        } else if (this.state.hotelTimezoneOffset) {
          dateEndDate.setTime(dateEndDate.getTime() - this.state.hotelTimezoneOffset);
        }
      }
      return dateEndDate.getTime();
    }
    return null;
  }
}
const defaultLiteralsStore = new LiteralsStore();
const stores = {};
const injectionKeys = {};
function getRootUid() {
  const instance = getCurrentInstance();
  return (instance == null ? void 0 : instance.uid) || 0;
}
function getRootElement() {
  var _a;
  const instance = getCurrentInstance();
  return (_a = instance == null ? void 0 : instance.proxy) == null ? void 0 : _a.$el;
}
function initializeStore(store) {
  var _a;
  const instance = getCurrentInstance();
  const hideFunction = (_a = instance == null ? void 0 : instance.exposed) == null ? void 0 : _a.hide;
  store.inited = true;
  store.hideFunction = hideFunction || (() => {
  });
}
function updateStore(toolProps) {
  const storeUid = getRootUid();
  const rootElement = getRootElement();
  const store = stores[storeUid];
  if (store.inited) {
    store.language = toolProps.language;
    store.rtl = toolProps.language === Locale.Arabic || toolProps.language === Locale.Hebrew;
    store.device = toolProps.device;
    store.extraData.initialize(toolProps.extraData);
    store.handlers.initialize(store.hideFunction, toolProps.actions);
    store.literals.initialize(toolProps.language, toolProps.device);
    store.styles.initialize(toolProps.styles, rootElement);
  } else {
    throw new Error(`error updating store ${storeUid}: store not inited`);
  }
}
function createStore(toolProps) {
  const uid = getRootUid();
  const storeInjectionKey = Symbol("useStore injection key");
  const store = reactive({
    uid,
    inited: false,
    language: Locale.English,
    device: DeviceKind.Desktop,
    hideFunction: () => {
    },
    extraData: new ExtraDataStore(),
    handlers: new HandlersStore(),
    literals: defaultLiteralsStore,
    styles: new StylesStore()
  });
  stores[uid] = store;
  injectionKeys[uid] = storeInjectionKey;
  provide(storeInjectionKey, store);
  provide("rootUID", uid);
  onMounted(() => {
    initializeStore(store);
    updateStore(toolProps);
  });
  return store;
}
function useStore() {
  const uid = inject("rootUID");
  if (uid !== void 0) {
    return inject(injectionKeys[uid]);
  }
  throw new Error("No UID found to load the store");
}
({
  [ToolModuleKind.EmailCapture]: "Your email address has been successfully added to our list.",
  [ToolModuleKind.SavedSearch]: "We will send you an email with your search very soon.",
  [ToolModuleKind.Form]: "We have received your form submission correctly"
});
({
  [ButtonActionKind.ApplyPromoCode]: "Apply promocode",
  [ButtonActionKind.OpenUrl]: "Continue",
  [ButtonActionKind.CloseTool]: "Close",
  [ButtonActionKind.OpenBookingEngine]: "Book Now",
  [ButtonActionKind.OpenMailClient]: "Contact Now",
  [ButtonActionKind.CallPhoneNumber]: "Call Now"
});
const stepsWrapper = ref();
[
  ToolModuleKind.SavedSearch,
  ToolModuleKind.EmailCapture,
  ToolModuleKind.Form
];
function hasLinkButton(modules) {
  return modules.find(
    (module2) => {
      var _a;
      return module2.moduleType === ToolModuleKind.Button && ((_a = module2.appearance) == null ? void 0 : _a.layout) === "link";
    }
  );
}
ref("Terms and conditions");
ref(false);
var now = function() {
  return root$1.Date.now();
};
const now$1 = now;
var reWhitespace = /\s/;
function trimmedEndIndex(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {
  }
  return index;
}
var reTrimStart = /^\s+/;
function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
var symbolTag = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var FUNC_ERROR_TEXT = "Expected a function";
var nativeMax = Math.max, nativeMin = Math.min;
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now$1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now$1());
  }
  function debounced() {
    var time = now$1(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
const _sfc_main$i = /* @__PURE__ */ defineComponent({
  __name: "XClose",
  props: {
    triggerDismiss: { type: Boolean, default: true }
  },
  setup(__props) {
    const store = useStore();
    const props = __props;
    const onClick = debounce(() => {
      var _a;
      if (props.triggerDismiss === true) {
        (_a = store.handlers) == null ? void 0 : _a.callHandler(ToolActionKind.Dismiss);
      }
    }, 200, { leading: true, trailing: false });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-xclose",
        onMousedown: _cache[0] || (_cache[0] = withModifiers(
          (...args) => unref(onClick) && unref(onClick)(...args),
          ["left"]
        )),
        onClick: _cache[1] || (_cache[1] = (...args) => unref(onClick) && unref(onClick)(...args))
      }, [
        createVNode(unref(CrossIcon), { class: "thn--tool-xclose__svg" })
      ], 32);
    };
  }
});
const defaultAppearance = {
  fontSize: 16,
  lineHeight: 16,
  letterSpacing: 0
};
function useTextAppearance(appearance = defaultAppearance, device = DeviceKind.Desktop, toolKind = ToolKind.Layer) {
  const {
    fontSize,
    lineHeight,
    letterSpacing
  } = appearance;
  const multiplier = device === DeviceKind.Mobile ? 0.8 : 1;
  const adjustedFontSize = Math.round(fontSize * multiplier);
  const adjustedLineHeight = Math.round(lineHeight);
  const adjustedLetterspacing = (letterSpacing != null ? letterSpacing : 0) / 100;
  return {
    fontSize: appendPx(adjustedFontSize < 14 && toolKind === ToolKind.Note ? 14 : adjustedFontSize),
    lineHeight: appendPx(adjustedLineHeight < 14 && toolKind === ToolKind.Note ? 14 : adjustedLineHeight),
    letterSpacing: !letterSpacing ? "normal" : appendEm(adjustedLetterspacing)
  };
}
const _hoisted_1$g = ["button-state", "moduleType", "data-module-id", "data-full-width"];
const _hoisted_2$9 = {
  key: 0,
  class: "thn--tool-button__back"
};
const _hoisted_3$5 = ["innerHTML"];
const _hoisted_4$5 = ["innerHTML"];
const _hoisted_5$3 = {
  key: 3,
  class: "thn--tool-button__sending loader"
};
const _hoisted_6$1 = /* @__PURE__ */ createElementVNode("div", { class: "la-ball-pulse" }, [
  /* @__PURE__ */ createElementVNode("div"),
  /* @__PURE__ */ createElementVNode("div"),
  /* @__PURE__ */ createElementVNode("div")
], -1);
const _hoisted_7$1 = [
  _hoisted_6$1
];
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  __name: "Button",
  props: {
    moduleProps: {},
    hasExtraSteps: {},
    isLinkLayout: { type: Boolean },
    toolKind: {}
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "0bd033d9": buttonPositionArHebLeft.value,
      "6e8ca88a": buttonPositionArHebRight.value
    }));
    const store = useStore();
    const props = __props;
    const buttonPositionArHebLeft = computed(() => (store == null ? void 0 : store.rtl) ? "flex-end" : "none");
    const buttonPositionArHebRight = computed(() => (store == null ? void 0 : store.rtl) ? "flex-start" : "none");
    const text = computed(() => {
      var _a;
      return store == null ? void 0 : store.literals.getActiveModuleText(
        props.moduleProps,
        ((_a = store == null ? void 0 : store.styles.fonts[props.moduleProps.moduleType]) == null ? void 0 : _a.textTransform) === TextTransform.Titlecase
      );
    });
    const rootStyle = computed(
      () => useTextAppearance(props.moduleProps.appearance, store == null ? void 0 : store.device, props.toolKind)
    );
    const onClick = debounce(() => {
      if ((store == null ? void 0 : store.handlers.buttonState) !== ButtonState.Sending) {
        if (props.hasExtraSteps && !props.moduleProps.id.includes("extra")) {
          if (stepsWrapper.value) {
            stepsWrapper.value.scrollTop = 0;
          }
          store == null ? void 0 : store.handlers.callHandler(getButtonActionType(props.hasExtraSteps));
        } else if (props.moduleProps.behaviour.type === ButtonActionKind.GoMainStep) {
          store == null ? void 0 : store.handlers.goBackToMainStep();
        } else {
          const buttonActionType = getButtonActionType(props.moduleProps.behaviour.type);
          store == null ? void 0 : store.handlers.callHandler(buttonActionType, props.moduleProps.id);
        }
      }
    }, 200, { leading: true, trailing: false });
    return (_ctx, _cache) => {
      var _a, _b, _c;
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          "thn--tool-button",
          { "inline-layout": _ctx.isLinkLayout }
        ]),
        "button-state": (_a = unref(store)) == null ? void 0 : _a.handlers.buttonState,
        style: normalizeStyle(rootStyle.value),
        moduleType: _ctx.moduleProps.moduleType,
        "data-module-id": _ctx.moduleProps.id,
        "data-full-width": (_b = _ctx.moduleProps.appearance) == null ? void 0 : _b.fullWidth,
        onMousedown: _cache[0] || (_cache[0] = withModifiers(
          (...args) => unref(onClick) && unref(onClick)(...args),
          ["left"]
        )),
        onClick: _cache[1] || (_cache[1] = (...args) => unref(onClick) && unref(onClick)(...args))
      }, [
        !_ctx.isLinkLayout ? (openBlock(), createElementBlock("div", _hoisted_2$9)) : createCommentVNode("", true),
        !_ctx.isLinkLayout ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: "thn--tool-button__label",
          innerHTML: text.value
        }, null, 8, _hoisted_3$5)) : (openBlock(), createElementBlock("span", {
          key: 2,
          innerHTML: text.value
        }, null, 8, _hoisted_4$5)),
        ((_c = unref(store)) == null ? void 0 : _c.handlers.buttonState) === unref(ButtonState).Sending && !_ctx.isLinkLayout ? (openBlock(), createElementBlock("div", _hoisted_5$3, _hoisted_7$1)) : createCommentVNode("", true)
      ], 46, _hoisted_1$g);
    };
  }
});
const _hoisted_1$f = ["innerHTML", "moduleType", "data-module-id"];
const _sfc_main$g = /* @__PURE__ */ defineComponent({
  __name: "Text",
  props: {
    moduleProps: {},
    toolKind: {}
  },
  setup(__props) {
    const moduleKindToDefault = {
      [ToolModuleKind.Heading]: {
        fontSize: 24,
        lineHeight: 24
      },
      [ToolModuleKind.Paragraph]: {
        fontSize: 16,
        lineHeight: 16
      },
      [ToolModuleKind.Button]: {
        fontSize: 18,
        lineHeight: 18
      }
    };
    const store = useStore();
    const props = __props;
    const text = computed(() => {
      var _a;
      return store == null ? void 0 : store.literals.getActiveModuleText(
        props.moduleProps,
        ((_a = store == null ? void 0 : store.styles.fonts[props.moduleProps.moduleType]) == null ? void 0 : _a.textTransform) === TextTransform.Titlecase
      );
    });
    const textAppearance = computed(
      () => props.moduleProps.appearance || moduleKindToDefault[props.moduleProps.moduleType]
    );
    const textStyle = computed(
      () => useTextAppearance(textAppearance.value, store == null ? void 0 : store.device, props.toolKind)
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-text",
        style: normalizeStyle(textStyle.value),
        innerHTML: text.value,
        moduleType: _ctx.moduleProps.moduleType,
        "data-module-id": _ctx.moduleProps.id
      }, null, 12, _hoisted_1$f);
    };
  }
});
const _hoisted_1$e = ["innerHTML", "data-module-id"];
const _sfc_main$f = /* @__PURE__ */ defineComponent({
  __name: "Activity",
  props: {
    moduleProps: {}
  },
  setup(__props) {
    const store = useStore();
    const props = __props;
    const text = computed(
      () => store == null ? void 0 : store.literals.getActivityLiteral(
        props.moduleProps.textKey,
        store == null ? void 0 : store.extraData.tokens
      )
    );
    const rootStyle = computed(() => useTextAppearance(props.moduleProps.appearance, store == null ? void 0 : store.device));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-activity",
        innerHTML: text.value,
        "data-module-id": _ctx.moduleProps.id,
        style: normalizeStyle(rootStyle.value)
      }, null, 12, _hoisted_1$e);
    };
  }
});
const _hoisted_1$d = ["data-module-id"];
const _sfc_main$e = /* @__PURE__ */ defineComponent({
  __name: "Icon",
  props: {
    moduleProps: {}
  },
  setup(__props) {
    const props = __props;
    const iconModule = computed(() => {
      const iconComponentName = `${toPascalCase(props.moduleProps.value)}Icon`;
      return defineAsyncComponent(() => import(`@thehotelsnetwork/icons/vue/personalization/${iconComponentName}.js`));
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-icon",
        "data-module-id": props.moduleProps.id,
        "data-module-special": true
      }, [
        createVNode(unref(iconModule), { class: "thn--tool-icon__svg" })
      ], 8, _hoisted_1$d);
    };
  }
});
const _hoisted_1$c = ["data-position", "data-device", "data-builder-mode", "data-text-direction"];
const _hoisted_2$8 = /* @__PURE__ */ createElementVNode("div", { class: "thn--tool-note__back" }, null, -1);
const _hoisted_3$4 = { class: "thn--tool-note__content" };
const _hoisted_4$4 = { class: "thn--tool-note__modules__wrapper" };
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  __name: "Note",
  props: {
    tool: {},
    context: {}
  },
  emits: [
    "hide",
    "hidden"
  ],
  setup(__props, { expose: __expose, emit: __emit }) {
    useCssVars((_ctx) => ({
      "4e77fdee": flipmarginRight.value,
      "e9c7610c": flipmarginLeft.value
    }));
    const noteModuleKindToComponentMap = {
      [ToolModuleKind.Paragraph]: _sfc_main$g,
      [ToolModuleKind.Activity]: _sfc_main$f,
      [ToolModuleKind.Button]: _sfc_main$h
    };
    const props = __props;
    const emit = __emit;
    const store = createStore(parseToolData({
      ...props,
      toolKind: ToolKind.Note
    }));
    const rootDom = ref();
    const hidden = ref(false);
    const { height: noteComponentHeight } = useElementSize(rootDom);
    const layout = computed(() => {
      const {
        content: {
          modules
        }
      } = props.tool;
      return {
        hasLinkLayoutButton: !!hasLinkButton(modules)
      };
    });
    const iconProps = computed(() => props.tool.content.modules.find((module2) => module2.moduleType === ToolModuleKind.Icon));
    const restModules = computed(() => props.tool.content.modules.filter(
      (module2) => module2.moduleType !== ToolModuleKind.Icon
    ));
    const { isSwiping, lengthX } = useSwipe(rootDom, {
      onSwipeEnd: () => {
        if (Math.abs(lengthX.value) > 150) {
          store.handlers.callHandler(ToolActionKind.Dismiss);
        }
      }
    });
    const rootStyle = computed(() => {
      const swipeStyles = {};
      if (isSwiping.value && rootDom.value) {
        const translateValue = -rootDom.value.getBoundingClientRect().width / 2 - lengthX.value;
        swipeStyles.transform = `translateX(${translateValue}px)`;
        swipeStyles.opacity = (100 - Math.abs(lengthX.value / 3)) / 100;
      }
      return {
        ...swipeStyles
      };
    });
    const transitionName = computed(() => {
      const { position } = props.tool.settings.devices[props.context.deviceViewport];
      return getTransitionName("fade", position);
    });
    const flipmarginRight = computed(() => (store == null ? void 0 : store.rtl) ? "none" : "12px");
    const flipmarginLeft = computed(() => (store == null ? void 0 : store.rtl) ? "12px" : "none");
    function show() {
      hidden.value = false;
    }
    function hide() {
      emit("hide");
      hidden.value = true;
    }
    function onHideLayout() {
      emit("hidden");
    }
    onUpdated(() => {
      updateStore(parseToolData({
        ...props,
        toolKind: ToolKind.Note
      }));
    });
    onMounted(() => {
      store.handlers.callHandler(ToolActionKind.Show);
      if (props.tool.settings.timing.pagetime) {
        setTimeout(() => {
          store.handlers.callHandler(ToolActionKind.Hide);
          hide();
        }, Number(props.tool.settings.timing.pagetime) * 1e3);
      }
    });
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        name: transitionName.value,
        appear: "",
        onAfterLeave: onHideLayout
      }, {
        default: withCtx(() => [
          withDirectives(createElementVNode("div", {
            class: "thn--tool thn--tool-note",
            ref_key: "rootDom",
            ref: rootDom,
            style: normalizeStyle(rootStyle.value),
            "data-position": _ctx.tool.settings.devices[_ctx.context.deviceViewport].position,
            "data-device": _ctx.context.deviceViewport,
            "data-builder-mode": _ctx.context.builderMode,
            "data-text-direction": unref(store).rtl ? "rtl" : "ltr"
          }, [
            _hoisted_2$8,
            createElementVNode("div", _hoisted_3$4, [
              iconProps.value ? (openBlock(), createBlock(_sfc_main$e, {
                key: 0,
                class: normalizeClass(["thn--tool-note__icon", [unref(noteComponentHeight) > 72 ? "icon-top" : "icon-center"]]),
                "data-module-id": iconProps.value.id,
                "data-module-special": true,
                "module-props": iconProps.value
              }, null, 8, ["class", "data-module-id", "module-props"])) : createCommentVNode("", true),
              createElementVNode("div", {
                class: normalizeClass([
                  "thn--tool-note__modules",
                  { "inline-layout": layout.value.hasLinkLayoutButton }
                ]),
                "data-add-module": true
              }, [
                createElementVNode("div", _hoisted_4$4, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(restModules.value, (moduleProps, moduleIndex) => {
                    return openBlock(), createBlock(resolveDynamicComponent(noteModuleKindToComponentMap[moduleProps.moduleType]), mergeProps({
                      class: "thn--tool-note-component",
                      key: moduleIndex,
                      "is-link-layout": layout.value.hasLinkLayoutButton,
                      "tool-kind": unref(ToolKind).Note
                    }, {
                      moduleProps
                    }), null, 16, ["is-link-layout", "tool-kind"]);
                  }), 128))
                ])
              ], 2)
            ]),
            createVNode(_sfc_main$i)
          ], 12, _hoisted_1$c), [
            [vShow, !hidden.value]
          ])
        ]),
        _: 1
      }, 8, ["name"]);
    };
  }
});
({
  colors: {
    heading: "#CCCCCC",
    paragraph: "#CCCCCC",
    icon: "#000000",
    buttonText: "#ffffff",
    buttonBackground: "#000000",
    background: {
      base: "#ffffff"
    }
  },
  fonts: {
    paragraph: {
      spec: {
        key: "Open+Sans",
        name: "Open Sans",
        cssName: "Open Sans",
        type: "sans-serif",
        fontType: FontType.Google,
        source: ""
      },
      style: "bold",
      textTransform: TextTransform.None
    },
    button: {
      spec: {
        key: "Open+Sans",
        name: "Open Sans",
        cssName: "Open Sans",
        type: "sans-serif",
        fontType: FontType.Google,
        source: ""
      },
      style: "bold",
      textTransform: TextTransform.None
    }
  },
  button: {
    style: ButtonStyleKind.Solid,
    cornerRadius: {
      kind: RadiusKind.Rounded
    },
    padding: {
      format: MeasureUnit.Pixels,
      right: 8,
      left: 8,
      top: 24,
      bottom: 24
    }
  },
  background: {
    opacity: 100,
    cornerRadius: {
      kind: RadiusKind.Rounded
    },
    image: {
      opacity: 10,
      alt: "alt text for background image",
      urls: {
        edited: "https://s3-eu-west-1.amazonaws.com/popups-photos/welcome/back_photo/1440_820/75b2b42a6a40e1a8186b2823c50c7c1a.jpg"
      }
    }
  },
  overlay: {
    opacity: 10,
    color: "#000000"
  }
});
const style = "";
export {
  _sfc_main$d as default
};
//# sourceMappingURL=note.es.js.map
